import React from 'react';
import styles from './Footer.module.scss';

interface Props {
  icon: React.ReactChild;
  href: string;
  label: string;
}

export function SocialButton({ href, icon, label }: Props) {
  return (
    <a href={href} className={styles.socialLink} target="_blank" rel="noreferrer" aria-label={label}>
      {icon}
    </a>
  );
}
